import { render, staticRenderFns } from "./PromoBannerAprils.vue?vue&type=template&id=4ed10222&"
import script from "./PromoBannerAprils.vue?vue&type=script&lang=js&"
export * from "./PromoBannerAprils.vue?vue&type=script&lang=js&"
import style0 from "./PromoBannerAprils.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PromoBannerAprils.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports